import { useQuery } from "@/api/swr/useQuery";
import { answerCategoryDetailSchema } from "@/schema/console/checking-assessments/AnswerCategoryDetail";

type Config = Parameters<typeof useQuery<typeof answerCategoryDetailSchema>>[2];

export function useGetPendingCategory(id: string, config?: Config) {
  return useQuery(
    answerCategoryDetailSchema,
    `/console/pending_assessments/answer_categories/${id}`,
    config,
  );
}
